import { AfterViewInit, Directive, ElementRef, Input, Renderer2 } from "@angular/core";
import { SignChangerDirective } from "@modules/core/directives/sign-changer.directive";

@Directive({
	selector: "[cardMask]",
	standalone: false
})
export class CardMaskDirective extends SignChangerDirective implements AfterViewInit {
	@Input() partLengths: { initLength: number; endLength: number } = {
		initLength: 6,
		endLength: 4
	};
	protected signToChange: string = "*";
	protected targetSign: string = "•";

	public constructor(
		protected el: ElementRef,
		protected renderer: Renderer2
	) {
		super(el, renderer);
	}

	public ngAfterViewInit(): void {
		super.ngAfterViewInit();

		this.convertElement();
	}

	private convertElement(): void {
		const firstElem = this.constructSpan(this.element.innerText.substring(0, this.partLengths.initLength));
		const maskElem = this.constructSpan(
			this.element.innerText.substring(
				this.partLengths.initLength,
				this.element.innerText.length - this.partLengths.endLength
			)
		);
		const lastElem = this.constructSpan(
			this.element.innerText.substring(this.element.innerText.length - this.partLengths.endLength)
		);
		const elements: HTMLSpanElement[] = [firstElem, maskElem, lastElem];
		this.renderer.addClass(maskElem, "font-bold");
		this.renderer.removeChild(this.element, this.element.firstChild);
		elements.forEach((newElement: HTMLSpanElement) => this.renderer.appendChild(this.element, newElement));
	}

	private constructSpan(text: string): HTMLSpanElement {
		const spanElem: HTMLSpanElement = this.renderer.createElement("span");
		this.renderer.appendChild(spanElem, this.renderer.createText(text));

		return spanElem;
	}
}
